import { render, staticRenderFns } from "./growth_process.vue?vue&type=template&id=b3b70438&scoped=true&"
import script from "./growth_process.vue?vue&type=script&lang=js&"
export * from "./growth_process.vue?vue&type=script&lang=js&"
import style0 from "./growth_process.vue?vue&type=style&index=0&id=b3b70438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b70438",
  null
  
)

export default component.exports